import { Logger } from '@sitecore-discover/react';

Logger.setLogLevel('info');
